import { useQuery } from "react-query";
import { getAllAppSources } from "api/Appointment";

export const useAllSources = () => {
    const { data, isLoading } = useQuery<Array<any> | any>(["app-sources"],
        () => {
            return getAllAppSources();
        },
    );

    return {
        data,
        isLoading,
    };
};
